import { useEffect, useRef } from 'react';
import { StageRanges } from '../utils/scheduleLineSchema';

type Line = {
  product?: string;
  stage?: string;
  dasFrom?: string;
  dasTo?: string;
  mandatory?: string;
};

type Args = {
  lines?: Line[];
  rowIds: string[];
  setValue: (name: any, value: any, options?: any) => void;
  uplByProductId: Record<string, boolean>;
  stageRanges: StageRanges;
};

export const useScheduleLineAutofill = ({
  lines,
  rowIds,
  setValue,
  uplByProductId,
  stageRanges,
}: Args) => {
  const previous = useRef<
    Record<string, { product: string; stage: string }>
  >({});

  useEffect(() => {
    const options = { shouldDirty: true, shouldValidate: true };
    (lines ?? []).forEach((line, index) => {
      const id = rowIds[index];
      if (!id) return;
      const product = line?.product ?? '';
      const stage = line?.stage ?? '';
      const before = previous.current[id];
      previous.current[id] = { product, stage };

      if (uplByProductId[product] === true) {
        if (line?.mandatory !== 'YES') {
          setValue(`lines.${index}.mandatory`, 'YES', options);
        }
      } else if (
        before &&
        before.product !== product &&
        product
      ) {
        setValue(`lines.${index}.mandatory`, 'NO', options);
      }

      const range = stageRanges[stage];
      if (
        before &&
        before.stage !== stage &&
        range?.dasFrom != null
      ) {
        setValue(
          `lines.${index}.dasFrom`,
          String(range.dasFrom),
          options
        );
      }
    });
  }, [lines, rowIds, uplByProductId, stageRanges, setValue]);
};
